var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4901 0.268799C24.3254 0.0975476 24.1009 0.00130087 23.8654 4.96702e-05C23.6298 -0.00244894 23.4041 0.0950509 23.2406 0.268799L8.50995 15.36C8.34278 15.5287 8.2476 15.76 8.2476 16C8.2476 16.24 8.34278 16.4713 8.50996 16.64L23.2406 31.735C23.4053 31.9138 23.6323 32.0175 23.8714 32.0213C24.1118 32.025 24.3425 31.93 24.5121 31.7563C24.6817 31.5825 24.7744 31.3463 24.7708 31.1013C24.7671 30.855 24.6658 30.6225 24.4901 30.455L10.3842 16L24.4901 1.5488C24.6573 1.38005 24.75 1.1488 24.75 0.908798C24.75 0.668798 24.6573 0.438784 24.4901 0.268799L24.4901 0.268799Z",
    fill: "#605E5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2381,
    height: 32,
    fill: "white",
    transform: "translate(32.1191 32) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/IconBack.e0e071ea93576e713bbbc159af5c0bed.svg";
export { ForwardRef as ReactComponent };